module.exports = __webpack_public_path__ + "static/media/unsupported-device.5c16de24.svg";